import axios from 'axios'

export const postalCodeRegexp = /^\d{3}-?\d{4}$/

export const fetchAddress = async (postalCode) => {
  if (!postalCodeRegexp.test(postalCode)) return Promise.reject(`Invalid postal code format: ${postalCode}`)

  return await axios.get(`/api/v2/post_code/${postalCode}`)
}
